import { render, staticRenderFns } from "./ListVesselPage.vue?vue&type=template&id=50bbe5e9&"
import script from "./ListVesselPage.vue?vue&type=script&lang=js&"
export * from "./ListVesselPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports